import React from 'react';
import PropTypes from 'prop-types';

export default function InformativeIcon(props) {
  const { fill, width, height } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.003 11.998'
    >
      <path
        id='União_92'
        data-name='União 92'
        d='M8476,20123a6,6,0,1,1,6,6A6,6,0,0,1,8476,20123Zm.895,0a5.1,5.1,0,1,0,5.107-5.1A5.116,5.116,0,0,0,8476.893,20123Zm4.547,3.082v-3.086a.561.561,0,1,1,1.121,0v3.086a.561.561,0,0,1-1.121,0Zm-.414-5.445a.975.975,0,1,1,.975.975A.975.975,0,0,1,8481.025,20120.635Z'
        transform='translate(-8475.998 -20117.002)'
        fill={fill}
      />
    </svg>
  );
}

InformativeIcon.defaultProps = {
  fill: '#fff',
  width: 12.003,
  height: 11.998
};

InformativeIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
